export const PROGRESS_BAR_CONFIGURATION: {
  partPercentageOfMilestones: {
    [key: number]: number[];
  };
} = {
  partPercentageOfMilestones: {
    1: [100],
    2: [50, 50],
    3: [20, 80 / 2, 80 / 2],
    4: [10, 90 / 3, 90 / 3, 90 / 3],
    5: [10, 90 / 4, 90 / 4, 90 / 4, 90 / 4],
  },
};
